import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import LoadingIndicatorComponent from './LoadingIndicatorComponent';
import TopMenu from './TopMenu';
import { clearMapState } from '../Actions/MapViewActions';
import { clearMunicipalityData } from '../Actions/MunicipalityActions';
import { fetchAllMunicipalities } from '../Utils/fetcherUtil';
import { capitalize, changeHtmlLang } from '../Utils/otherUtils';
import logo from '../Images/Icons/logo_white.svg';
import mapPinLocation from '../Images/Icons/icon_map_pin_your_location.svg';

const FrontPage = () => {
  const [municipalities, setMunicipalities] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const {
    language,
    text: { frontPage: pageText },
  } = useSelector(state => state.Language);

  const loadMunicipalities = () => {
    setLoading(true);
    fetchAllMunicipalities().then((result) => {
      setMunicipalities(result.data);
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    changeHtmlLang(language);
    dispatch(clearMunicipalityData());
    dispatch(clearMapState());

    loadMunicipalities();
  }, []);

  const renderMunicipalities = () => (
    <div className="frontpage__municipality-list">
      { municipalities.length > 0 ?
        municipalities.map(municipality => municipality.name)
          .sort((a, b) => a.localeCompare(b, 'sv'))
          .map(name =>
          (
            <div key={name}>
              <button
                className="frontpage__municipality-button"
                onClick={() => { dispatch(push(`/${language}/${name}`)); }}
              >
                <img className="frontpage__municipality-icon" src={mapPinLocation} alt="map-pin" />
                { capitalize(name) }
              </button>
            </div>
        ))
      : <p>{pageText.loadMunicipalitiesError}</p>}
    </div>
  );

  return (
    <div className="frontpage">
      <div className="frontpage__background-overlay">
        <TopMenu />
        <article aria-label={pageText.heading}>
          <div className="frontpage__header">
            <img className="frontpage__logo" src={logo} alt="vh-icon" />
            <p>{pageText.preamble}</p>
          </div>
          { loading ? <LoadingIndicatorComponent /> : renderMunicipalities() }
        </article>
      </div>
    </div>
  );
};

export default FrontPage;



// WEBPACK FOOTER //
// ./src/Components/FrontPage.js